var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFF4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4984 19.2516C17.6661 18.4193 17.25 17.4187 17.25 16.25C17.25 15.0812 17.6661 14.0807 18.4984 13.2484C19.3307 12.4161 20.3312 12 21.5 12C22.6687 12 23.6693 12.4161 24.5016 13.2484C25.3339 14.0807 25.75 15.0812 25.75 16.25C25.75 17.4187 25.3339 18.4193 24.5016 19.2516C23.6693 20.0839 22.6687 20.5 21.5 20.5C20.3312 20.5 19.3307 20.0839 18.4984 19.2516ZM13 26.875V26.025C13 25.4229 13.1551 24.8697 13.4654 24.3654C13.7756 23.861 14.1872 23.4757 14.7 23.2094C15.7979 22.6604 16.9135 22.2489 18.0469 21.9747C19.1802 21.7006 20.3312 21.5632 21.5 21.5625C22.6687 21.5618 23.8198 21.6992 24.9531 21.9747C26.0865 22.2503 27.2021 22.6618 28.3 23.2094C28.8135 23.475 29.2254 23.8603 29.5357 24.3654C29.8459 24.8704 30.0007 25.4236 30 26.025V26.875C30 27.4594 29.7921 27.9598 29.3763 28.3763C28.9605 28.7928 28.4601 29.0007 27.875 29H15.125C14.5406 29 14.0405 28.7921 13.6247 28.3763C13.209 27.9605 13.0007 27.4601 13 26.875Z",
    fill: "#085855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfp);
export default __webpack_public_path__ + "static/media/pfp.ba7a38a76eaf89f008ba08b143b9202f.svg";
export { ForwardRef as ReactComponent };